import React from 'react';
import PropTypes from 'prop-types';
import { Col, FlexboxGrid } from 'rsuite';
import { SmtpAccountType } from '../../../../interfaces/smtpAccount';
import { SmtpAccountSetupInstructions } from '../SmtpAccountSetupInstructions';
import SmtpAccountForm from '../SmtpAccountForm';

const DisabledStyle = {
  filter: 'blur(1px)',
  pointerEvents: 'none'
};

const SmtpAccountPage = ({ data, disabled = false }) => (
  <FlexboxGrid style={disabled ? DisabledStyle : {}}>
    <FlexboxGrid.Item
      componentClass={Col}
      xs={24}
      sm={24}
      md={14}
      style={{ marginBottom: 10 }}
    >
      <SmtpAccountSetupInstructions />
    </FlexboxGrid.Item>
    <FlexboxGrid.Item componentClass={Col} xs={24} sm={24} md={10}>
      <SmtpAccountForm data={data} disabled={disabled} />
    </FlexboxGrid.Item>
  </FlexboxGrid>
);

SmtpAccountPage.propTypes = {
  data: SmtpAccountType,
  disabled: PropTypes.bool
};

SmtpAccountPage.defaultProps = {
  data: {},
  disabled: false
};

export default SmtpAccountPage;
